import { render, staticRenderFns } from "./insUserCurrent.vue?vue&type=template&id=08127d46&"
import script from "./insUserCurrent.vue?vue&type=script&lang=js&"
export * from "./insUserCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports